export function parseLocation (url) {
  const a = document.createElement('a')
  a.href = url
  return a
}

export function getQueryParams (url) {
  if (typeof url === 'string') {
    url = parseLocation(url)
  }

  const parentQuery = url && url.search && url.search.substr(1)
  const parentQueryParams = {}

  if (parentQuery) {
    parentQuery.split('&').forEach(param => {
      param = param.split('=')

      parentQueryParams[param[0]] = param[1]
    })
  }

  return parentQueryParams
}

export function isFromRemote () {
  return !!window.regilyRemote
}

export function simulateSlowConnection () {
  const urlParams = getQueryParams(window.location)
  return urlParams && !!urlParams.simulateSlowConnection
}

export function isFromAffiliate () {
  const urlParams = getQueryParams(window.location)
  return urlParams && !!urlParams.isAffiliate
}

export function getRemoteSettings () {
  const script = document.currentScript || document.querySelector('script[src*=".regily.com/"]')
  const urlParams = getQueryParams(script.src)

  return urlParams && {
    registrationUrl: urlParams.partnerRegistrationUrl && decodeURIComponent(urlParams.partnerRegistrationUrl),
    redirectUrl: urlParams.partnerRedirectUrl && decodeURIComponent(urlParams.partnerRedirectUrl),
    sessionId: urlParams.partnerRedirectUrl && decodeURIComponent(urlParams.sessionId)
  }
}

export function getCustomData (scriptUrl) {
  try {
    const url = new URL(scriptUrl)
    return url.searchParams.get('customData')
  } catch (e) {
    return false
  }
}

export function getDynamicSettings () {
  const script = document.currentScript || document.querySelector('script[src*=".regily.com/"]') || document.querySelector('script[src*="/playground.js"]')
  const settings = {}
  const documentDataset = document.documentElement.dataset || {}
  const scriptDataset = script ? script.dataset : {}

  for (let key in documentDataset) {
    if (key.indexOf('regily') === 0) {
      settings[key] = documentDataset[key]
    }
  }

  for (let key in scriptDataset) {
    if (key.indexOf('regily') === 0) {
      settings[key] = scriptDataset[key]
    }
  }

  return settings
}


export function delegateEvent(
  rootElement,
  targetSelector,
  eventType,
  handler
) {
  const listener = function(event) {
    const element = event.target;
    const isValidTarget =
      !!element &&
      targetSelector.some(selector => element.matches && element.matches(selector));

    if (isValidTarget) {
      handler();
    }
  }

  rootElement.addEventListener(eventType, listener, false);

  return {
    remove: function () {
      rootElement.removeEventListener(eventType, listener, false)
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/browserStructure.js